import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Reset window scroll on every pathname change. Keyed on pathname (not full
// location) so hash anchors like /#artists and /#portfolio still jump via
// the browser's native hash behavior without the effect re-firing.
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}
